<template>
  <div>
    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">S/N</th>
                <th>
                  <button class="btn p-0" @click="setSortBy('date')">
                    Date Uploaded
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'date'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'date_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th v-if="uploaderUserType == userTypeMainAdmin">
                  <button class="btn p-0" @click="setSortBy('school')">
                    School
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'school'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'school_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th
                  v-if="
                    uploaderUserType == userTypeMainAdmin ||
                    uploaderUserType == userTypeSchoolAdmin ||
                    uploaderUserType == userTypeInstructorSchoolAdmin
                  "
                >
                  <button class="btn p-0" @click="setSortBy('userType')">
                    User Type
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'userType'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'userType_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th
                  v-if="
                    uploaderUserType == userTypeMainAdmin ||
                    uploaderUserType == userTypeSchoolAdmin ||
                    uploaderUserType == userTypeInstructorSchoolAdmin
                  "
                >
                  <button class="btn p-0" @click="setSortBy('name')">
                    Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('fileName')">
                    File
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'fileName'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'fileName_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('remarks')">
                    Remarks
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'remarks'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'remarks_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th v-if="uploaderUserType == userTypeStudent">
                  <button class="btn p-0" @click="setSortBy('instructorName')">
                    Instructor
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'instructorName'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'instructorName_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th v-if="uploaderUserType != userTypeStudent">
                  <button class="btn p-0" @click="setSortBy('sentTo')">
                    {{
                      uploaderUserType == userTypeInstructor &&
                      type == "Student Document"
                        ? "Instructor Email"
                        : "Notification Sent To"
                    }}
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'sentTo'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'sentTo_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th v-if="type != 'Student Document'">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(doc, i) in documents" :key="doc.Id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td>{{ doc.DateUploadedDisplay }}</td>
                <td v-if="uploaderUserType == userTypeMainAdmin">
                  {{ doc.SchoolName }}
                </td>
                <td
                  v-if="
                    uploaderUserType == userTypeMainAdmin ||
                    uploaderUserType == userTypeSchoolAdmin ||
                    uploaderUserType == userTypeInstructorSchoolAdmin
                  "
                >
                  {{ doc.UserType }}
                </td>
                <td
                  v-if="
                    uploaderUserType == userTypeMainAdmin ||
                    uploaderUserType == userTypeSchoolAdmin ||
                    uploaderUserType == userTypeInstructorSchoolAdmin
                  "
                >
                  {{ doc.Name }}
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-link px-0"
                    @click="downloadFile(doc)"
                  >
                    {{ doc.FileName }}
                  </button>
                </td>
                <td>{{ doc.Remarks }}</td>
                <td v-if="uploaderUserType == userTypeStudent">
                  {{ doc.InstructorName }}
                </td>
                <td v-if="uploaderUserType != userTypeStudent">
                  {{ doc.SentTo }}
                </td>
                <td v-if="type != 'Student Document'">
                  <button
                    @click="deleteDocument(doc.Id)"
                    class="btn btn-sm btn-link p-0"
                  >
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </button>
                </td>
              </tr>
              <tr v-if="documents && !documents.length">
                <td colspan="10" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-0" v-if="documents && documents.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          documents.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config";
export default {
  props: ["uploaderUserType", "type", "schoolId", "userId", "name", "userType"],
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      documents: [],
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getDocumentList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    getDocumentList() {
      let param = {
        Token: this.tokenObj.Token,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        UserId: this.userId,
        SchoolId: this.schoolId,
        Name: this.name,
        UserType: this.userType,
      };
      this.$store.state.isLoading = true;
      API.document
        .getDocumentList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.documents = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    deleteDocument(docId) {
      let param = {
        Token: this.tokenObj.Token,
        Id: docId,
        UserType: this.uploaderUserType,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the document?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.document
            .deleteDocument(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.paging.CurrentPage = 1;
                this.getDocumentList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    //file download
    downloadFile(doc) {
      let param = {
        Token: this.tokenObj.Token,
        Id: doc.Id,
      };
      API.document
        .getDocumentFile(param)
        .then((response) => {
          const base64String = response.data.data.split(",")[1];
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: "application/octet-stream",
          });
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = doc.FileName;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.log(error);
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getDocumentList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getDocumentList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getDocumentList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getDocumentList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getDocumentList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "school":
          if (this.paging.SortBy === "school") {
            this.paging.SortBy = "school_desc";
          } else if (this.paging.SortBy === "school_desc") {
            this.paging.SortBy = "school";
          } else {
            this.paging.SortBy = "school";
          }
          break;
        case "userType":
          if (this.paging.SortBy === "userType") {
            this.paging.SortBy = "userType_desc";
          } else if (this.paging.SortBy === "userType_desc") {
            this.paging.SortBy = "userType";
          } else {
            this.paging.SortBy = "userType";
          }
          break;
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "date":
          if (this.paging.SortBy === "date") {
            this.paging.SortBy = "date_desc";
          } else if (this.paging.SortBy === "date_desc") {
            this.paging.SortBy = "date";
          } else {
            this.paging.SortBy = "date";
          }
          break;
        case "fileName":
          if (this.paging.SortBy === "fileName") {
            this.paging.SortBy = "fileName_desc";
          } else if (this.paging.SortBy === "fileName_desc") {
            this.paging.SortBy = "fileName";
          } else {
            this.paging.SortBy = "fileName";
          }
          break;
        case "remarks":
          if (this.paging.SortBy === "remarks") {
            this.paging.SortBy = "remarks_desc";
          } else if (this.paging.SortBy === "remarks_desc") {
            this.paging.SortBy = "remarks";
          } else {
            this.paging.SortBy = "remarks";
          }
          break;
        case "instructorName":
          if (this.paging.SortBy === "instructorName") {
            this.paging.SortBy = "instructorName_desc";
          } else if (this.paging.SortBy === "instructorName_desc") {
            this.paging.SortBy = "instructorName";
          } else {
            this.paging.SortBy = "instructorName";
          }
          break;
        case "sentTo":
          if (this.paging.SortBy === "sentTo") {
            this.paging.SortBy = "sentTo_desc";
          } else if (this.paging.SortBy === "sentTo_desc") {
            this.paging.SortBy = "sentTo";
          } else {
            this.paging.SortBy = "sentTo";
          }
          break;
      }
      this.getDocumentList();
    },
  },
  created() {
    this.getDocumentList();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Shared/DocumentTable.vue